<ion-content class="container">
  <div class="container">
    <ion-row>
      <ion-col size="12" size-md="4">
        <ion-row class="h-100 ion-justify-content-between">
          <ion-col size="12" *ngIf="isPayrollEnabled && appUpdateServiceService.getPlatform() !== 'web'">
            <div class="Employee-master-cardBox h-100">
              <div>
                <h4 class="fs-14 yellow font_semibold mt-5 cp">Mark Attendance</h4>
              </div>
              <div class="Employee-master-contentCard cp p-10">
                <ion-button type="button" class="action-ion-button fs-14 font_semibold success" [disabled]="disablePunchButtons" (click)="markAttendance(1)">
                  <ion-icon name="time-outline" class="mr-10"></ion-icon>
                  Punch In
                </ion-button>
                <ion-button type="button" class="action-ion-button fs-14 font_semibold danger" [disabled]="disablePunchButtons" (click)="markAttendance(2)">
                  <ion-icon name="time-outline" class="mr-10"></ion-icon>
                  Punch Out
                </ion-button>
              </div>
            </div>
          </ion-col>

          <ion-col size="12">
            <div class="Employee-master-cardBox h-100">
              <div>
                <div>
                  <h4 class="fs-14 yellow font_semibold mt-5 cp">Employee Master</h4>
                </div>
                <div class="Employee-master-contentCard cp" (click)="onClickEmployeeMasterPopup('Active Employee')">
                  <div class="p-10">
                    <p class="fs-14 font_semibold">Active employees</p>
                    <p class="fs-16 font_semibold mt-5">{{activeNo || '00'}}</p>
                  </div>
                </div>
                <div class="Employee-master-contentCard cp" (click)="onClickEmployeeMasterPopup('Exited Employee')">
                  <div class="p-10">
                    <p class="fs-14 font_semibold">Exited employees</p>
                    <p class="fs-16 font_semibold mt-5">{{exitedNo || '00'}}</p>
                  </div>
                </div>
              </div>
              <div>
                <h4 class="fs-14 yellow font_semibold mt-20 cp">PMS</h4>
              </div>
              <div class="pms-contentcard cp" (click)="onClickEmployeeMasterPopup('Goal Setting Status')">
                <div class="p-10" [class.disabled]="!isPMSModuleAvailable" [attr.disabled]="!isPMSModuleAvailable ? true : null">
                  <p class="fs-14 font_semibold">Overall Goal Setting Status</p>
                  <p class="fs-16 font_semibold mt-5">{{countOfGoalSetting || '00'}}</p>
                </div>
              </div>
              <div class="pms-contentcard cp" (click)="onClickEmployeeMasterPopup('Goal Review Status')">
                <div class="p-10" [class.disabled]="!isPMSModuleAvailable" [attr.disabled]="!isPMSModuleAvailable ? true : null">
                  <p class="fs-14 font_semibold">Overall Goal Review Status</p>
                  <p class="fs-16 font_semibold mt-5">{{countOfReviewStatus || '00'}}</p>
                </div>
              </div>
              <div class="pms-contentcard  cp" (click)="onClickEmployeeMasterPopup('Manager Approval Status')">
                <div class="p-10" [class.disabled]="!isPMSModuleAvailable" [attr.disabled]="!isPMSModuleAvailable ? true : null">
                  <p class="fs-14 font_semibold">Approved by Manager</p>
                  <p class="fs-16 font_semibold mt-5">{{countOfManagerApprovalStatus || '00'}}</p>
                </div>
              </div>
              <div>
                <h4 class="fs-14 yellow font_semibold mt-20 cp">IDP & PIP</h4>
              </div>
              <div class="IDPandPIP-contentcard cp">
                <div class="p-10">
                  <p class="fs-14 font_semibold">Emp. In IDP</p>
                  <p class="fs-16 font_semibold mt-5">coming soon</p>
                </div>
              </div>
              <div class="IDPandPIP-contentcard cp">
                <div class="p-10">
                  <p class="fs-14 font_semibold">Emp. In PIP</p>
                  <p class="fs-16 font_semibold mt-5">coming soon</p>
                </div>
              </div>
            </div>
          </ion-col>

          <ion-col size="12">
            <div class="SocialFeedcardBox h-100">
              <div class="display-space-between">
                <p class="fs-14 font_semibold">Social Feed</p>
                <!-- <img src="" alt=""> -->
                <button class="social-feed-btn" (click)="onClickAddNewSocialFieldPopup()" *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'">&#x2b; &nbsp; Add New</button>
                <p *ngIf="loggedInUserRole == 'Employee' || loggedInUserRole == 'Manager' || loggedInUserRole == 'HOD'" class="fs-12">{{socialFeedCount || 0}}</p>
              </div>
              <div class="socialFeedContent">
                <div class="socialFeedCardBoxContent" *ngFor="let data of socialFeedCardData; let id = index">
                  <div class="socialFeedCardBoxIcon" *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'">
                    <div>
                      <span class="material-icons socialFeedCardBoxDeleteIcon cp" (click)="onClickDeleteNewSocialFieldPopup(data.id)">delete</span>
                    </div>
                    <div>
                      <span class="material-icons socialFeedCardBoxEditIcon cp" (click)="onClickEditNewSocialFieldPopup(id)">edit</span>
                    </div>
                  </div>

                  <div class="verticle-center" (click)="onClickOpenFeedURL(data.feedURL)">
                    <div>
                      <img class="SocialFeedMediaIcon cp" [src]="getIconByType(data.feedType)" [alt]="data.feedType + ' icon'" />
                    </div>
                    <div>
                      <p class="socialFeedName ml-10 cp">{{data.feedName}}</p>
                      <p class="fs-12 text_gray1 font_regular ml-10 mt-5 pr-20 cp mx-w-200">{{data.remarks}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ion-col>

          <ion-col size="12">
            <div class="CareercardBox h-100">
              <div>
                <p class="fs-14 font_semibold">Career/ Professional Information</p>
              </div>
              <div>
                <div class="mt-20">
                  <ion-row>
                    <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
                      <div class="careerProfessionalInformationTabs">
                        <a class="fs-14 font_semibold" (click)="showContent('getPersonalDetailsTab')" [ngClass]="{'active-tab': selectedTab === 'getPersonalDetailsTab'}">Personal Details</a>
                      </div>
                    </ion-col>
                    <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
                      <div class="careerProfessionalInformationTabs">
                        <a class="fs-14 font_semibold" (click)="showContent('getProfessionalDetailsTab')" [ngClass]="{'active-tab': selectedTab === 'getProfessionalDetailsTab'}">Professional Details</a>
                      </div>
                    </ion-col>
                  </ion-row>

                  <div *ngIf="selectedTab === 'getPersonalDetailsTab'">
                    <ion-row>
                      <ion-col size="12">
                        <div class="mt-20">
                          <h4 class="fs-12 font_semibold">{{getEmployeeByIdData.salutation}} {{getEmployeeByIdData.firstName}} {{getEmployeeByIdData.lastName}}</h4>
                          <p class="mt-5 fs-10 font_regular">{{getEmployeeByIdData.designation}}</p>
                        </div>
                      </ion-col>
                    </ion-row>
                    <ion-row class="mt-10">
                      <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
                        <div>
                          <h4 class="fs-12 font_semibold">Employee ID</h4>
                          <p class="fs-10 font_regular">{{getEmployeeByIdData.empCode}}</p>
                        </div>
                      </ion-col>

                      <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
                        <div>
                          <h4 class="fs-12 font_semibold">Email ID</h4>
                          <p class="fs-10 font_regular">{{getEmployeeByIdData.email}}</p>
                        </div>
                      </ion-col>
                    </ion-row>
                    <ion-row class="mt-10">
                      <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
                        <div>
                          <h4 class="fs-12 font_semibold">D.O.B</h4>
                          <p class="fs-10 font_regular">{{getEmployeeByIdData.dateOfBirth | date:'dd/MM/yyyy'}}</p>
                        </div>
                      </ion-col>

                      <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
                        <div>
                          <h4 class="fs-12 font_semibold">Date of joining</h4>
                          <p class="fs-10 font_regular">{{getEmployeeByIdData.dateOfJoining | date:'dd/MM/yyyy'}}</p>
                        </div>
                      </ion-col>
                    </ion-row>
                    <ion-row class="mt-10">
                      <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
                        <div>
                          <h4 class="fs-12 font_semibold">Department</h4>
                          <p class="fs-10 font_regular">{{getEmployeeByIdData.department}}</p>
                        </div>
                      </ion-col>

                      <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
                        <div>
                          <h4 class="fs-12 font_semibold">Contact</h4>
                          <p class="fs-10 font_regular">{{getEmployeeByIdData.contactNo}}</p>
                        </div>
                      </ion-col>
                    </ion-row>

                    <div style="padding-top: 20px;" *ngIf="!mobileResponsiveService.hideForTabletAndBelow">
                      <button type="button" class="viewDetails m-10" (click)="onClickViewDetails('view')">View Details</button>
                    </div>
                  </div>

                  <div *ngIf="selectedTab === 'getProfessionalDetailsTab'">
                    <ion-row>
                      <ion-col size-sm="6" size-md="12" size-lg="12" size-xs="6">
                        <div class="mt-20">
                          <h4 class="fs-12 font_semibold">{{getEmployeeByIdData.salutation}} {{getEmployeeByIdData.firstName}} {{getEmployeeByIdData.lastName}}</h4>
                          <p class="mt-5 fs-10 font_regular">{{getEmployeeByIdData.designation}}</p>
                        </div>
                      </ion-col>
                    </ion-row>
                    <ion-row class="mt-10">
                      <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
                        <div>
                          <h4 class="fs-12 font_semibold">Employee ID</h4>
                          <p class="fs-10 font_regular">{{getEmployeeByIdData.empCode}}</p>
                        </div>
                      </ion-col>

                      <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
                        <div>
                          <h4 class="fs-12 font_semibold">Pro. Email ID</h4>
                          <p class="fs-10 font_regular">{{getEmployeeByIdData.officialEmail}}</p>
                        </div>
                      </ion-col>
                    </ion-row>
                    <ion-row class="mt-10">
                      <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
                        <div>
                          <h4 class="fs-12 font_semibold">Direct reportees</h4>
                          <p class="fs-10 font_regular">{{getEmployeeByIdData.noOfDirectReportees}}</p>
                        </div>
                      </ion-col>

                      <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
                        <div>
                          <h4 class="fs-12 font_semibold">Dotted reportees</h4>
                          <p class="fs-10 font_regular">{{getEmployeeByIdData.noOfIndirectReportees}}</p>
                        </div>
                      </ion-col>
                    </ion-row>
                    <ion-row class="mt-10">
                      <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
                        <div>
                          <h4 class="fs-12 font_semibold">Band</h4>
                          <p class="fs-10 font_regular">{{getEmployeeByIdData.band}}</p>
                        </div>
                      </ion-col>

                      <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
                        <div>
                          <h4 class="fs-12 font_semibold">Annual review form</h4>
                          <p class="fs-10 font_regular">(clickable)</p>
                        </div>
                      </ion-col>
                    </ion-row>
                    <div style="padding-top: 20px;" *ngIf="!mobileResponsiveService.hideForTabletAndBelow">
                      <button type="button" class="viewDetails m-10" (click)="onClickViewDetails('view')">View Details</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ion-col>
        </ion-row>
      </ion-col>

      <ion-col size="12" size-md="4">
        <ion-row class="h-100 ion-justify-content-between">
          <ion-col size="12">
            <div class="QuickScarchCardBox h-100">
              <p class="fs-14 font_semibold pb-10">Quick Search</p>
              <ion-row class="mt-15">
                <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
                  <div>
                    <!-- (click)="onClickQuickSearchPopup('employeeSearch')" -->
                    <button type="button" class="quickScarchBtn" (click)="onClickEmployeeMasterPopup('Employee Search')">
                      <span class="material-icons mr-5">search</span>
                      Employee Search
                    </button>
                  </div>
                </ion-col>
                <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
                  <div>
                    <button type="button" class="quickScarchBtn" (click)="onClickQuickSearchPopup('helpDesk')">
                      <img class="mr-5" src="./assets/icon/HelpDesk.svg" alt="" />
                      Help Desk
                    </button>
                  </div>
                </ion-col>
              </ion-row>
              <ion-row class="mt-10">
                <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
                  <div>
                    <button type="button" class="quickScarchBtn" (click)="onClickQuickSearchPopup('hrHandBook')">
                      <img class="mr-5" src="./assets/icon/HRHandBook.svg" alt="" />
                      HR HandBook
                    </button>
                  </div>
                </ion-col>
                <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
                  <div>
                    <button type="button" class="quickScarchBtn">
                      <span class="material-icons mr-5">help</span>
                      FAQs
                    </button>
                  </div>
                </ion-col>
              </ion-row>
            </div>
          </ion-col>

          <ion-col size="12">
            <div class="pendingStatusCardBox h-100" *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'">
              <p class="fs-14 font_semibold">Pending Setups</p>
              <ion-row>
                <ion-col size="12" size-lg="6" *ngFor="let setups of pendingSetups; let i = index;">
                  <div class="pending-setups-table">
                    <table>
                      <thead>
                        <tr>
                          <th>Modules</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let setup of setups">
                          <td>{{ setup.componentName }}</td>
                          <td>
                            <div *ngIf="setup?.isRegistered; else notInSideBar">
                              <img [src]="setup?.setupCompleted ? '././assets/icon/Approve.svg' : '././assets/icon/Reject.svg'" alt="" />
                            </div>
                            <ng-template #notInSideBar>-</ng-template>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </ion-col>
              </ion-row>
            </div>

            <div class="taskManagementCardBox h-100" *ngIf="loggedInUserRole == 'Employee' || loggedInUserRole == 'Manager' || loggedInUserRole == 'HOD' || loggedInUserRole == 'Admin'">
              <div class="display-space-between">
                <div>
                  <p class="fs-14 font_semibold">Task Management</p>
                </div>
              </div>

              <div class="display-space-between mt-15">
                <div class="taskManagementTabTabs">
                  <a class=" font_semibold" (click)="taskManagementContent('Review Meeting')" [ngClass]="{'active-tab': selecttaskManagementTab === 'Review Meeting'}">Review Meeting</a>
                </div>
                <div class="taskManagementTabTabs">
                  <a class=" font_semibold" (click)="taskManagementContent('Daily Work Management')" [ngClass]="{'active-tab': selecttaskManagementTab === 'Daily Work Management'}">Daily Work Management</a>
                </div>
              </div>

              <div class="mt-15" *ngIf="selecttaskManagementTab === 'Review Meeting'">
                <div *ngIf="loggedInUserRole == 'Employee' || loggedInUserRole == 'Admin'">
                  <div class="text-end">
                    <mat-form-field class="max-w-250 w-100 mat mat-height40  mat-input-style mr-15 mt-10">
                      <mat-date-range-input [rangePicker]="fromToDateTaskAssignedToMe">
                        <input readonly matStartDate dateInput placeholder="Start date" [(ngModel)]="taskAssignedToMeFromDate" (dateChange)="onDateChangetaskAssignedToMe()" [disabled]="!isTaskManagementModuleAvailable" />
                        <input readonly matEndDate dateInput placeholder="End date" [(ngModel)]="taskAssignedToMeToDate" (dateChange)="onDateChangetaskAssignedToMe()" [disabled]="!isTaskManagementModuleAvailable" />
                      </mat-date-range-input>
                      <mat-datepicker-toggle matIconSuffix [for]="fromToDateTaskAssignedToMe"></mat-datepicker-toggle>
                      <mat-date-range-picker #fromToDateTaskAssignedToMe></mat-date-range-picker>
                    </mat-form-field>
                  </div>
                  <div class="taskManagementTabContent">
                    <div><img src="././assets/icon/TaskAssignImg.svg" alt="" /></div>
                    <div>
                      <button [disabled]="!isTaskManagementModuleAvailable" [class.disabled]="!isTaskManagementModuleAvailable" (click)="onClickSwitchToReviewMeetingMyTask()">Task Assigned to Me - {{taskAssignedToMeCount}}</button>
                    </div>
                  </div>
                </div>

                <div *ngIf="loggedInUserRole == 'Manager' || loggedInUserRole == 'HOD'">
                  <div class="text-end">
                    <mat-form-field class="max-w-250 w-100 mat mat-height40  mat-input-style mr-15 mt-10">
                      <mat-date-range-input [rangePicker]="fromToDateTaskAssignedToMe">
                        <input readonly matStartDate dateInput placeholder="Start date" [(ngModel)]="taskAssignedToMeFromDate" (dateChange)="onDateChangetaskAssignedToMe()" [disabled]="!isTaskManagementModuleAvailable" />
                        <input readonly matEndDate dateInput placeholder="End date" [(ngModel)]="taskAssignedToMeToDate" (dateChange)="onDateChangetaskAssignedToMe()" [disabled]="!isTaskManagementModuleAvailable" />
                      </mat-date-range-input>
                      <mat-datepicker-toggle matIconSuffix [for]="fromToDateTaskAssignedToMe"></mat-datepicker-toggle>
                      <mat-date-range-picker #fromToDateTaskAssignedToMe></mat-date-range-picker>
                    </mat-form-field>
                  </div>
                  <div class="taskManagementTabContent">
                    <div><img src="././assets/icon/TaskAssignImg.svg" alt="" /></div>
                    <div class="TaskAssignedBtn">
                      <button [disabled]="!isTaskManagementModuleAvailable" [class.disabled]="!isTaskManagementModuleAvailable" (click)="onClickSwitchToReviewMeetingMyTask()">Task Assigned to Me - {{taskAssignedToMeCount}}</button>
                      <button [disabled]="!isTaskManagementModuleAvailable" [class.disabled]="!isTaskManagementModuleAvailable" (click)="onClickSwitchToReviewMeetingAssignTask()">Task Assigned by Me - {{taskAssignedByMeCount}}</button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="mt-15" *ngIf="selecttaskManagementTab === 'Daily Work Management'">
                <div *ngIf="loggedInUserRole == 'Employee' || loggedInUserRole == 'Admin'">
                  <div class="text-end">
                    <mat-form-field class="w150 mat-height40 mat-input-style mt-10">
                      <input matInput [matDatepicker]="incrementEligibilityDate" placeholder="DD/MM/YYYY" [(ngModel)]="dailyWorkManagementDate" (dateChange)="onDateChangetaskAssignedToMe()" [disabled]="!isTaskManagementModuleAvailable" />
                      <mat-datepicker-toggle matIconSuffix [for]="incrementEligibilityDate"></mat-datepicker-toggle>
                      <mat-datepicker #incrementEligibilityDate></mat-datepicker>
                    </mat-form-field>
                  </div>
                  <div class="taskManagementTabContent">
                    <div><img src="././assets/icon/TaskAssignImg.svg" alt="" /></div>
                    <div>
                      <button [disabled]="!isTaskManagementModuleAvailable" [class.disabled]="!isTaskManagementModuleAvailable" (click)="onClickSwitchToDWMMyTask()">DWM Assigned to Me - {{DWMAssignedToMeCount}}</button>
                    </div>
                  </div>
                </div>
                <div *ngIf="loggedInUserRole == 'Manager' || loggedInUserRole == 'HOD'">
                  <div class="text-end">
                    <mat-form-field class="w150 mat-height40 mat-input-style mt-10">
                      <input matInput [matDatepicker]="incrementEligibilityDate" placeholder="DD/MM/YYYY" [(ngModel)]="dailyWorkManagementDate" (dateChange)="onDateChangetaskAssignedToMe()" [disabled]="!isTaskManagementModuleAvailable" />
                      <mat-datepicker-toggle matIconSuffix [for]="incrementEligibilityDate"></mat-datepicker-toggle>
                      <mat-datepicker #incrementEligibilityDate></mat-datepicker>
                    </mat-form-field>
                  </div>
                  <div class="taskManagementTabContent">
                    <div><img src="././assets/icon/TaskAssignImg.svg" alt="" /></div>
                    <div class="TaskAssignedBtn">
                      <button [disabled]="!isTaskManagementModuleAvailable" [class.disabled]="!isTaskManagementModuleAvailable" (click)="onClickSwitchToDWMMyTask()">DWM Assigned to Me - {{DWMAssignedToMeCount}}</button>
                      <button [disabled]="!isTaskManagementModuleAvailable" [class.disabled]="!isTaskManagementModuleAvailable" (click)="onClickSwitchToDWMTeamDWM()">DWM Assigned by Me - {{DWMAssignedByMeCount}}</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ion-col>

          <ion-col size="12">
            <div class="OACardBox h-100">
              <div class="display-space-between">
                <p class="fs-14 font_semibold">Organisation Announcement</p>
                <div *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'">
                  <button class="OrganisationAnnouncementBtn" (click)="onClickCreateAnnouncementPopup()">
                    <span class="material-icons fs-12 mr-5">edit</span>
                    Create
                  </button>
                </div>
              </div>
              <ion-row>
                <ion-col size="12">
                  <div class="OrganisationAnnouncementTable">
                    <table>
                      <thead>
                        <tr>
                          <th>Announcement</th>
                          <th>Date of Publish</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let data of getAnnouncementTableData; let i = index">
                          <td class="cp" (click)="onEditAnnouncementData(i)">{{data.subject}}</td>
                          <td>{{data.updatedAt | date:'dd/MM/yyyy'}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </ion-col>
              </ion-row>
            </div>
          </ion-col>

          <ion-col size="12">
            <div class="fellingTodaycardBox h-100">
              <div>
                <button type="button" class="howAreYouFellingTodayBtn">How are you feeling today?</button>
              </div>
              <div class="w-100 mt-10 text-end">
                <mat-form-field class="w150 mat-height40 mat-input-style">
                  <input matInput [matDatepicker]="incrementEligibilityDate" placeholder="DD/MM/YYYY" [max]="howAreYouFellingToDate" [(ngModel)]="howAreYouFellingTodayDate" (dateChange)="setHowAreYouFellingTodayDate()" />
                  <mat-datepicker-toggle matIconSuffix [for]="incrementEligibilityDate"></mat-datepicker-toggle>
                  <mat-datepicker #incrementEligibilityDate></mat-datepicker>
                </mat-form-field>
              </div>

              <div class="w-100 mt-10">
                <div *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'Admin' || loggedInUserRole == 'PHI Admin'">
                  <ion-row>
                    <ion-col size="6" size-xs="6">
                      <div class="howAreYouFellingTodayCardBox">
                        <div class="fs-14 font_semibold mt-5 text-end w-100">{{getUserExcellentFelling}}</div>
                        <div><img src="././assets/icon/Star.png" alt="" /></div>
                        <p class="fs-14 font_semibold text-center mt-5">Excellent</p>
                      </div>
                    </ion-col>
                    <ion-col size="6" size-xs="6">
                      <div class="howAreYouFellingTodayCardBox">
                        <p class="fs-14 font_semibold mt-5 text-end w-100">{{getUserGreatFelling}}</p>
                        <img src="././assets/icon/Laugh.png" alt="" />
                        <p class="fs-14 font_semibold text-center mt-5">Great</p>
                      </div>
                    </ion-col>
                    <ion-col size="12" size-xs="6">
                      <div class="howAreYouFellingTodayCardBox">
                        <p class="fs-14 font_semibold mt-5 text-end w-100">{{getUserOkayFelling}}</p>
                        <img src="././assets/icon/Bored.png" alt="" />
                        <p class="fs-14 font_semibold text-center mt-5">Okay</p>
                      </div>
                    </ion-col>
                    <ion-col size="6" size-xs="6">
                      <div class="howAreYouFellingTodayCardBox">
                        <p class="fs-14 font_semibold mt-5 text-end w-100">{{getUserNotGreatFelling}}</p>
                        <img src="././assets/icon/Mask.png" alt="" />
                        <p class="fs-14 font_semibold text-center mt-5">Not Great</p>
                      </div>
                    </ion-col>
                  </ion-row>
                </div>

                <div *ngIf="loggedInUserRole == 'Manager' || loggedInUserRole == 'Employee' || loggedInUserRole == 'HOD'">
                  <ion-row>
                    <ion-col size="12" size-xs="6">
                      <div class="howAreYouFellingTodayCardBox" [ngClass]="{'active': selectedMood === 'Excellent', 'disabled': isMoodSelectionDisabled  || selectedMood !== null}" (click)="setUserHowAreYourFellingToday('Excellent')" [class.non-clickable]="selectedMood !== null">
                        <div>
                          <img src="././assets/icon/Star.png" alt="" style="margin-top: -5px;" />
                        </div>
                        <p class="fs-14 font_semibold text-center mt-5">Excellent</p>
                      </div>
                    </ion-col>

                    <ion-col size="12" size-xs="6">
                      <div class="howAreYouFellingTodayCardBox" [ngClass]="{'active': selectedMood === 'Great', 'disabled': isMoodSelectionDisabled || selectedMood !== null}" (click)="setUserHowAreYourFellingToday('Great')" [class.non-clickable]="selectedMood !== null">
                        <img src="././assets/icon/Laugh.png" alt="" style="margin-top: -5px;" />
                        <p class="fs-14 font_semibold text-center mt-5">Great</p>
                      </div>
                    </ion-col>
                    <ion-col size="12" size-xs="6">
                      <div class="howAreYouFellingTodayCardBox" [ngClass]="{'active': selectedMood === 'Okay', 'disabled': isMoodSelectionDisabled || selectedMood !== null}" (click)="setUserHowAreYourFellingToday('Okay')" [class.non-clickable]="selectedMood !== null">
                        <img src="././assets/icon/Bored.png" alt="" style="margin-top: -5px;" />
                        <p class="fs-14 font_semibold text-center mt-5">Okay</p>
                      </div>
                    </ion-col>

                    <ion-col size="12" size-xs="6">
                      <div class="howAreYouFellingTodayCardBox" [ngClass]="{'active': selectedMood === 'Not_Great', 'disabled': isMoodSelectionDisabled || selectedMood !== null}" (click)="setUserHowAreYourFellingToday('Not_Great')" [class.non-clickable]="selectedMood !== null">
                        <img src="././assets/icon/Mask.png" alt="" style="margin-top: -5px;" />
                        <p class="fs-14 font_semibold text-center mt-5">Not Great</p>
                      </div>
                    </ion-col>
                  </ion-row>
                </div>
              </div>
            </div>
          </ion-col>
        </ion-row>
      </ion-col>

      <ion-col size="12" size-md="4">
        <ion-row class="h-100 ion-justify-content-between">
          <ion-col size="12">
            <div class="CompentenCardBox h-100">
              <div>
                <h4 class="fs-14 yellow font_semibold mt-5 cp">Competency</h4>
                <div class="Competency-card-box cp">
                  <div class="display-space-between cp" (click)="onClickCompetencySetStatusPopup('Competency Set')" *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'" [class.disabled]="!isCompetencyModuleAvailable" [attr.disabled]="!isCompetencyModuleAvailable ? true : null">
                    <p class="fs-14 font_semibold">Competency Set</p>
                    <p class="fs-14 font_semibold">{{competenciesSet || ''}}</p>
                  </div>

                  <div class="display-space-between cp" (click)="onClickCompetencySetStatusPopup('Competency Score')" *ngIf="loggedInUserRole == 'Manager' || loggedInUserRole == 'Employee' || loggedInUserRole == 'HOD' || loggedInUserRole == 'Admin'" [class.disabled]="!isCompetencyModuleAvailable" [attr.disabled]="!isCompetencyModuleAvailable ? true : null">
                    <p class="fs-14 font_semibold">Competency Score</p>
                    <p class="fs-14 font_semibold">{{scoreForDashboard?scoreForDashboard:'NA'}}</p>
                  </div>

                  <div class="hr"></div>
                  <div class="display-space-between cp" (click)="onClickCompetencySetStatusPopup('Evaluated by Manager')" *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'" [class.disabled]="!isCompetencyModuleAvailable" [attr.disabled]="!isCompetencyModuleAvailable ? true : null">
                    <p class="fs-14 font_semibold">Evaluated by Manager</p>
                    <p class="fs-14 font_semibold">{{evaluatedCompetencies || ''}}</p>
                  </div>

                  <div class="display-space-between cp" (click)="onClickCompetencySetStatusPopup('Competency Rating')" *ngIf="loggedInUserRole == 'Manager' || loggedInUserRole == 'HOD' || loggedInUserRole == 'Employee' || loggedInUserRole == 'Admin'" [class.disabled]="!isCompetencyModuleAvailable" [attr.disabled]="!isCompetencyModuleAvailable ? true : null">
                    <p class="fs-14 font_semibold">Competency Rating</p>
                    <p class="fs-14 font_semibold">{{competencyRatingDashboard?competencyRatingDashboard:'NA'}}</p>
                  </div>
                </div>
              </div>

              <div *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'">
                <h4 class="fs-14 yellow font_semibold mt-20 cp">Increments & variable pay</h4>
                <div class="IandVPay-card-box cp">
                  <div class="display-space-between " (click)="onClickredirectToIncrement()">
                    <p class="fs-14 font_semibold" [class.disabled]="!isIncrementModuleAvailable" [attr.disabled]="!isIncrementModuleAvailable ? true : null">Increment budget</p>
                    <p class="fs-14 font_semibold" [class.disabled]="!isIncrementModuleAvailable" [attr.disabled]="!isIncrementModuleAvailable ? true : null">{{incrementBudgetPercentage || '00'}} ({{sharedService.transformNumber(incrementBudgetAmount)|| '00'}})</p>
                  </div>
                  <div class="hr"></div>
                  <div class="display-space-between" (click)="onClickredirectToVP()">
                    <p class="fs-14 font_semibold" [class.disabled]="!isVariablePayModuleAvailable" [attr.disabled]="!isVariablePayModuleAvailable ? true : null">Variable Pay budget</p>
                    <p class="fs-14 font_semibold text-center" [class.disabled]="!isVariablePayModuleAvailable" [attr.disabled]="!isVariablePayModuleAvailable ? true : null">
                      ({{vpFrequencyMonth}} )
                      <br />
                      {{vpBudgetPercentage || '00'}} ({{vpBudgetAmount || '00'}})
                    </p>
                  </div>
                </div>
              </div>

              <div>
                <h4 class="fs-14 yellow font_semibold mt-20 cp">Rewards & Recognition</h4>
                <div class="RewardsandRecognition-card-box cp">
                  <div class="display-space-between">
                    <p class="fs-14 font_semibold">R&R nominated</p>
                    <p class="fs-14 font_semibold">coming soon</p>
                  </div>
                  <div class="hr"></div>
                  <div class="display-space-between">
                    <p class="fs-14 font_semibold">R&R won</p>
                    <p class="fs-14 font_semibold">coming soon</p>
                  </div>
                </div>
              </div>

              <div>
                <h4 class="fs-14 yellow font_semibold mt-20 cp">Learning & development</h4>
                <div class="LandD-card-box cp">
                  <div class="display-space-between">
                    <p class="fs-14 font_semibold">Training recommended</p>
                    <p class="fs-14 font_semibold">coming soon</p>
                  </div>
                  <div class="hr"></div>
                  <div class="display-space-between">
                    <p class="fs-14 font_semibold">Training attended</p>
                    <p class="fs-14 font_semibold">coming soon</p>
                  </div>
                </div>
              </div>
            </div>
          </ion-col>

          <ion-col size="12">
            <div class="newEmployeeCardBox h-100">
              <div class="display-between">
                <p class="fs-14 font_semibold">Welcome New Employee</p>
                <p class="fs-12 font_regular">{{getAddNewEmployeeTotalEmp || '0'}}</p>
              </div>
              <div>
                <div class="newEmployeeCardContent">
                  <ion-row class="pb-10">
                    <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
                      <div class="newEmployeeTabs">
                        <a class="fs-14 font_semibold" (click)="showNewEmpContent('PreviousMonthTab')" [ngClass]="{'active-tab': selectedNewEmpTab === 'PreviousMonthTab'}">Previous Month</a>
                      </div>
                    </ion-col>
                    <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
                      <div class="newEmployeeTabs">
                        <a class="fs-14 font_semibold" (click)="showNewEmpContent('CurrentMonthTab')" [ngClass]="{'active-tab': selectedNewEmpTab === 'CurrentMonthTab'}">Current Month</a>
                      </div>
                    </ion-col>
                  </ion-row>

                  <div *ngIf="selectedNewEmpTab === 'PreviousMonthTab'">
                    <div class="newEmployeeTabsContent">
                      <ng-container *ngFor="let data of getAddNewEmployeeData">
                        <div class="verticle-center p-5">
                          <img class="" src="././assets/icon/CirclePersonIcon.svg" alt="" />
                          <div class="ml-10">
                            <h4 class="fs-12 font_semibold">{{'data.name'}}</h4>
                            <p class="fs-10 font_regular verticle-center text_blue cp" (click)="onClickSendMailNewEmployeePopup('data', 'welcome')">
                              Send Wishes
                              <span class="material-icons fs-12 ml-5">send</span>
                            </p>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                    <div class="sendToAllBtn p-5">
                      <button type="button" (click)="onClickSendMailNewEmployeePopup(getAddNewEmployeeData, 'welcome')" [ngClass]="{'disabled': !getAddNewEmployeeData || getAddNewEmployeeData.length === 0}">
                        <span class="material-icons fs-12 mr-5">redo</span>
                        Send to all
                      </button>
                    </div>
                  </div>

                  <div *ngIf="selectedNewEmpTab === 'CurrentMonthTab'">
                    <div class="newEmployeeTabsContent">
                      <ng-container *ngFor="let data of getAddNewEmployeeData">
                        <div class="verticle-center p-5">
                          <img class="" src="././assets/icon/CirclePersonIcon.svg" alt="" />
                          <div class="ml-10">
                            <h4 class="fs-12 font_semibold">{{data.name}}</h4>
                            <p class="fs-10 font_regular verticle-center text_blue cp mt-5" (click)="onClickSendMailNewEmployeePopup(data, 'welcome')">
                              Send Wishes
                              <span class="material-icons fs-12 ml-5">send</span>
                            </p>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                    <div class="sendToAllBtn p-5">
                      <button type="button" (click)="onClickSendMailNewEmployeePopup(getAddNewEmployeeData, 'welcome')" [ngClass]="{'disabled': !getAddNewEmployeeData || getAddNewEmployeeData.length === 0}">
                        <span class="material-icons fs-12 mr-5">redo</span>
                        Send to all
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ion-col>

          <ion-col size="12">
            <div class="celebrationsCardBox h-100">
              <ion-row>
                <ion-col size="12">
                  <!-- <div class="display-between">
                    <p class="fs-14 font_semibold">Birthdays/ Marriage Anniversaries</p>
                    <p class="fs-12 font_regular">{{BirthdaysMarriageAnniversariesTotalEmp || '0'}}</p>
                  </div> -->
                  <div class="flex items-center display-between phi-gap-12 w-100">
                    <span class="fs-14 font_semibold">Birthdays</span>
                    <span class="fs-12 font_regular">{{ BirthdaysMarriageAnniversariesTotalEmp || '0' }}</span>

                    <!-- Switch + tooltip -->
                    <label class="switch flex items-center" matTooltip="Enable/Disable Birthday  Wishes" *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'">
                      <input type="checkbox" [(ngModel)]="toggleBirthdayAnniversary" (click)="checkToggle('birthday')" />
                      <span class="slider round"></span>
                    </label>
                    <span class="material-icons mail-icon mt-10" matTooltip="Design Birthday Wishes" (click)="onClickOpenCreate('Create Email Body for landing page')" *ngIf="toggleBirthdayAnniversary && (loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'||loggedInUserRole == 'Admin')">mail</span>
                  </div>

                  <div>
                    <div class="celebracionTab">
                      <ion-row>
                        <ion-col size="12">
                          <div class="display-space-between">
                            <div class="BMAcelebrationTabs">
                              <a class="fs-14 font_semibold" (click)="showBMAcelebrationContent('yesterDay')" [ngClass]="{'active-tab': selectedBMACelebrationTab === 'yesterDay'}">Yesterday</a>
                            </div>
                            <div class="BMAcelebrationTabs text-center">
                              <a class="fs-14 font_semibold " (click)="showBMAcelebrationContent('toDay')" [ngClass]="{'active-tab': selectedBMACelebrationTab === 'toDay'}">Today</a>
                            </div>
                            <div class="BMAcelebrationTabs">
                              <a class="fs-14 font_semibold" (click)="showBMAcelebrationContent('nextDay')" [ngClass]="{'active-tab': selectedBMACelebrationTab === 'nextDay'}">Tommorrow</a>
                            </div>
                          </div>
                        </ion-col>
                      </ion-row>

                      <div *ngIf="selectedBMACelebrationTab === 'yesterDay'">
                        <div class="newEmployeeTabsContent">
                          <ion-row>
                            <ng-container *ngFor="let data of getBirthdaysAndAnniversariesYesterDayData">
                              <ion-col size="12">
                                <div class="verticle-center mt-5">
                                  <img class="" src="././assets/icon/CakeIcon.svg" alt="" />
                                  <div class="ml-10">
                                    <h4 class="fs-12 font_semibold">{{data.name}}</h4>
                                    <p class="fs-10 font_regular verticle-center text_blue cp mt-5" (click)="onClickSendMailNewEmployeePopup(data, 'birthday')">
                                      Send Wishes
                                      <span class="material-icons fs-12 ml-5">send</span>
                                    </p>
                                  </div>
                                </div>
                              </ion-col>
                            </ng-container>
                          </ion-row>
                        </div>
                        <ion-row class="mt-10">
                          <ion-col size="12">
                            <div class="sendToAllBtn">
                              <button type="button" (click)="onClickSendMailNewEmployeePopup(getBirthdaysAndAnniversariesYesterDayData,'birthday')" [ngClass]="{'disabled': !getBirthdaysAndAnniversariesYesterDayData || getBirthdaysAndAnniversariesYesterDayData.length === 0}">
                                <span class="material-icons fs-12 mr-5">redo</span>
                                Send to all
                              </button>
                            </div>
                          </ion-col>
                        </ion-row>
                      </div>

                      <div *ngIf="selectedBMACelebrationTab === 'toDay'">
                        <div class="newEmployeeTabsContent">
                          <ion-row>
                            <ng-container *ngFor="let data of getBirthdaysAndAnniversariesToDayData">
                              <ion-col size="12">
                                <div class="verticle-center mt-5">
                                  <img class="" src="././assets/icon/CakeIcon.svg" alt="" />
                                  <div class="ml-10">
                                    <h4 class="fs-12 font_semibold">{{data.name}}</h4>
                                    <p class="fs-10 font_regular verticle-center text_blue cp mt-5" (click)="onClickSendMailNewEmployeePopup(data, 'birthday')">
                                      Send Wishes
                                      <span class="material-icons fs-12 ml-5">send</span>
                                    </p>
                                  </div>
                                </div>
                              </ion-col>
                            </ng-container>
                          </ion-row>
                        </div>
                        <ion-row class="mt-10">
                          <ion-col size="12">
                            <div class="sendToAllBtn">
                              <button type="button" (click)="onClickSendMailNewEmployeePopup(getBirthdaysAndAnniversariesToDayData, 'birthday')" [ngClass]="{'disabled': !getBirthdaysAndAnniversariesToDayData || getBirthdaysAndAnniversariesToDayData.length === 0}">
                                <span class="material-icons fs-12 mr-5">redo</span>
                                Send to all
                              </button>
                            </div>
                          </ion-col>
                        </ion-row>
                      </div>

                      <div *ngIf="selectedBMACelebrationTab === 'nextDay'">
                        <div class="newEmployeeTabsContent">
                          <ion-row>
                            <ng-container *ngFor="let data of getBirthdaysAndAnniversariesNextDayData">
                              <ion-col size="12">
                                <div class="verticle-center mt-5">
                                  <img class="" src="././assets/icon/CakeIcon.svg" alt="" />
                                  <div class="ml-10">
                                    <h4 class="fs-12 font_semibold">{{data.name}}</h4>
                                    <p class="fs-10 font_regular verticle-center text_blue cp mt-5" (click)="onClickSendMailNewEmployeePopup(data, 'birthday')">
                                      Send Wishes
                                      <span class="material-icons fs-12 ml-5">send</span>
                                    </p>
                                  </div>
                                </div>
                              </ion-col>
                            </ng-container>
                          </ion-row>
                        </div>
                        <ion-row class="mt-10">
                          <ion-col size="12">
                            <div class="sendToAllBtn">
                              <button type="button" (click)="onClickSendMailNewEmployeePopup(getBirthdaysAndAnniversariesNextDayData, 'birthday')" [ngClass]="{'disabled': !getBirthdaysAndAnniversariesNextDayData || getBirthdaysAndAnniversariesNextDayData.length === 0}">
                                <span class="material-icons fs-12 mr-5">redo</span>
                                Send to all
                              </button>
                            </div>
                          </ion-col>
                        </ion-row>
                      </div>
                    </div>
                  </div>
                </ion-col>
              </ion-row>

              <ion-row class="mt-20">
                <ion-col size="12">
                  <!-- <div class="display-between">
                    <p class="fs-14 font_semibold">Work Anniversaries</p>
                    <p class="fs-12 font_regular">{{WorkAnniversariesTotalEmp || 0}}</p>
                  </div> -->
                  <div class="flex items-center display-between phi-gap-12 w-100">
                    <span class="fs-14 font_semibold">Work Anniversaries</span>
                    <span class="fs-12 font_regular">{{WorkAnniversariesTotalEmp || 0}}</span>

                    <!-- Switch + tooltip -->
                    <label class="switch flex items-center" matTooltip="Enable/Disable Anniversary Wishes" *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'">
                      <input type="checkbox" [(ngModel)]="toggleAnniversary" (click)="checkToggle('anniversary')" />
                      <span class="slider round"></span>
                    </label>

                    <!-- Mail icon -->
                    <span class="material-icons mail-icon mt-10" matTooltip="Design Anniversary Wishes" *ngIf="toggleAnniversary && (loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'||loggedInUserRole == 'Admin')" (click)="onClickOpenCreate('Create Email Body for anniversary wishes')">mail</span>
                  </div>

                  <div>
                    <div class="celebracionTab">
                      <ion-row>
                        <ion-col size="12">
                          <div class="display-space-between">
                            <div class="WAcelebrationTabs">
                              <a class="fs-14 font_semibold" (click)="showWAcelebrationContent('Yesterday')" [ngClass]="{'active-tab': selectedWACelebrationTab === 'Yesterday'}">Yesterday</a>
                            </div>
                            <div class="WAcelebrationTabs">
                              <a class="fs-14 font_semibold" (click)="showWAcelebrationContent('Today')" [ngClass]="{'active-tab': selectedWACelebrationTab === 'Today'}">Today</a>
                            </div>
                            <div class="WAcelebrationTabs">
                              <a class="fs-14 font_semibold" (click)="showWAcelebrationContent('Tommorrow')" [ngClass]="{'active-tab': selectedWACelebrationTab === 'Tommorrow'}">Tommorrow</a>
                            </div>
                          </div>
                        </ion-col>
                      </ion-row>

                      <div *ngIf="selectedWACelebrationTab === 'Yesterday'">
                        <div class="workAnniversariesTabsContent">
                          <ion-row>
                            <ng-container *ngFor="let data of getWorkAnniversariesByYesterdayDateData">
                              <ion-col size="12">
                                <div class="verticle-center mt-5">
                                  <img class="" src="././assets/icon/PartyIcon.svg" alt="" />
                                  <div class="ml-10">
                                    <h4 class="fs-12 font_semibold">{{data.name}}</h4>
                                    <p class="fs-10 font_regular verticle-center text_blue cp" (click)="onClickSendMailNewEmployeePopup(data, 'work anniversary')">
                                      Send Wishes
                                      <span class="material-icons fs-12 ml-5 cp">send</span>
                                    </p>
                                  </div>
                                </div>
                              </ion-col>
                            </ng-container>
                          </ion-row>
                        </div>
                        <ion-row class="mt-10">
                          <ion-col size="12">
                            <div class="sendToAllBtn">
                              <button type="button" (click)="onClickSendMailNewEmployeePopup(getWorkAnniversariesByYesterdayDateData, 'work anniversary')" [ngClass]="{'disabled': !getWorkAnniversariesByYesterdayDateData || getWorkAnniversariesByYesterdayDateData.length === 0}">
                                <span class="material-icons fs-12 mr-5">redo</span>
                                Send to all
                              </button>
                            </div>
                          </ion-col>
                        </ion-row>
                      </div>

                      <div *ngIf="selectedWACelebrationTab === 'Today'">
                        <div class="workAnniversariesTabsContent">
                          <ion-row>
                            <ng-container *ngFor="let data of getWorkAnniversariesByToDayDateData">
                              <ion-col size="12">
                                <div class="verticle-center mt-5">
                                  <img class="" src="././assets/icon/PartyIcon.svg" alt="" />
                                  <div class="ml-10">
                                    <h4 class="fs-12 font_semibold">{{data.name}}</h4>
                                    <p class="fs-10 font_regular verticle-center text_blue cp" (click)="onClickSendMailNewEmployeePopup(data, 'work anniversary')">
                                      Send Wishes
                                      <span class="material-icons fs-12 ml-5 cp">send</span>
                                    </p>
                                  </div>
                                </div>
                              </ion-col>
                            </ng-container>
                          </ion-row>
                        </div>
                        <ion-row class="mt-10">
                          <ion-col size="12">
                            <div class="sendToAllBtn">
                              <button type="button" (click)="onClickSendMailNewEmployeePopup(getWorkAnniversariesByToDayDateData, 'work anniversary')" [ngClass]="{'disabled': !getWorkAnniversariesByToDayDateData || getWorkAnniversariesByToDayDateData.length === 0}">
                                <span class="material-icons fs-12 mr-5">redo</span>
                                Send to all
                              </button>
                            </div>
                          </ion-col>
                        </ion-row>
                      </div>

                      <div *ngIf="selectedWACelebrationTab === 'Tommorrow'">
                        <div class="workAnniversariesTabsContent">
                          <ion-row>
                            <ng-container *ngFor="let data of getWorkAnniversariesByTommorrowDateData">
                              <ion-col size="12">
                                <div class="verticle-center mt-5">
                                  <img class="" src="././assets/icon/PartyIcon.svg" alt="" />
                                  <div class="ml-10">
                                    <h4 class="fs-12 font_semibold">{{data.name}}</h4>
                                    <p class="fs-10 font_regular verticle-center text_blue cp" (click)="onClickSendMailNewEmployeePopup(data, 'work anniversary')">
                                      Send Wishes
                                      <span class="material-icons fs-12 ml-5 cp">send</span>
                                    </p>
                                  </div>
                                </div>
                              </ion-col>
                            </ng-container>
                          </ion-row>
                        </div>
                        <ion-row class="mt-10">
                          <ion-col size="12">
                            <div class="sendToAllBtn">
                              <button type="button" (click)="onClickSendMailNewEmployeePopup(getWorkAnniversariesByTommorrowDateData, 'work anniversary')" [ngClass]="{'disabled': !getWorkAnniversariesByTommorrowDateData || getWorkAnniversariesByTommorrowDateData.length === 0}">
                                <span class="material-icons fs-12 mr-5">redo</span>
                                Send to all
                              </button>
                            </div>
                          </ion-col>
                        </ion-row>
                      </div>
                    </div>
                  </div>
                </ion-col>
              </ion-row>
            </div>
          </ion-col>
        </ion-row>
      </ion-col>
    </ion-row>
    <!-- <ion-row>
      <ion-col size-sm="12" size-md="8" size-lg="8" size-xs="12">
        <div class="leaveAndAttendanceCardBox">
          <ion-row>
            <ion-col size-sm="12" size-md="3" size-lg="3" size-xs="12">
              <div class="display-space-between">
                <p class="fs-14 font_semibold">Leave and Attendance</p>
              </div>
            </ion-col>
            <div>Coming Soon</div>
            
            <!-- <ion-col size-sm="12" size-md="9" size-lg="9" size-xs="12" *ngIf="loggedInUserRole == 'Employee' || loggedInUserRole == 'Manager' || loggedInUserRole == 'HOD'">
              <div class="display-space-between">
                <div class="verticle-center">
                  <div><img src="././assets/icon/timeMachineImg.svg" alt=""></div>
                  <div class="pl-5">
                    <p class="fs-12 text_blue">Hours - Min.</p>
                    <p class="fs-10 text_grey">Spend Today</p>
                  </div>
                </div>
                
                <div><p class="fs-12 mw-180">0 Absences in this Month 18.50 Earned Leave Available</p></div>
                
                <div>
                  <mat-form-field  class="mat-height40 mat-input-style" style="width: 100px;">
                    <mat-select placeholder="Select Year">
                      <mat-option value="Jan">Jan</mat-option>
                      <mat-option value="Feb">Feb</mat-option>
                      <mat-option value="Mar">Mar</mat-option>
                      <mat-option value="Jun">Jun</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                
                <div *ngIf="loggedInUserRole != 'Manager' || loggedInUserRole == 'HOD'">
                  <span class="yellow fs-26 material-icons">notifications</span>
                </div>
              </div>
            </ion-col> --
          </ion-row>
          <div>
            <!-- <div class="mt-10">
              <ion-row class="display-space-between">
                <ion-col size-sm="12" size-md="7" size-lg="7" size-xs="12">
                  <div class="verticle-center">
                    <div class="leaveAndAttendanceTabs" *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'Employee' || loggedInUserRole == 'Manager' || loggedInUserRole == 'HOD'">
                      <a class="fs-14 font_semibold" (click)="showLeaveAndAttendanceContent('TodaysAbsentees')" [ngClass]="{'active-tab': selectLeaveAndAttendanceTab === 'TodaysAbsentees'}">Today's Absentees</a>
                    </div>
                    <div class="leaveAndAttendanceTabs ml-10" *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'Admin' || loggedInUserRole == 'PHI Admin'|| loggedInUserRole == 'Manager' || loggedInUserRole == 'HOD'">
                      <a class="fs-14 font_semibold" (click)="showLeaveAndAttendanceContent('attendanceForMonth')" [ngClass]="{'active-tab': selectLeaveAndAttendanceTab === 'attendanceForMonth'}">Attendance For The Month</a>
                    </div>
                    <div class="leaveAndAttendanceTabs ml-10" *ngIf="loggedInUserRole == 'Manager' || loggedInUserRole == 'HOD'">
                      <a class="fs-14 font_semibold" (click)="showLeaveAndAttendanceContent('teamView')" [ngClass]="{'active-tab': selectLeaveAndAttendanceTab === 'teamView'}">Team View</a>
                    </div>
                  </div>
                </ion-col>
                <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12" *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'">
                  <div class="display-space-between ml-10">
                    <div *ngIf="selectLeaveAndAttendanceTab === 'attendanceForMonth'">
                      <mat-form-field class="w150 mat-height40 mat-input-style">
                        <mat-select placeholder="Select" placeholder="Serach employee">
                          <mat-option value="Employee">Employee</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div *ngIf="selectLeaveAndAttendanceTab === 'attendanceForMonth'">
                      <mat-form-field class="w100 mat-height40 mat-input-style">
                        <mat-select placeholder="Select" placeholder="Serach Month">
                          <mat-option value="Feb">Feb</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                </ion-col>
                
                <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12" *ngIf="loggedInUserRole == 'Manager' || loggedInUserRole == 'HOD'">
                  <div class="display-space-between ml-10">
                    <div *ngIf="selectLeaveAndAttendanceTab === 'attendanceForMonth'">
                      <mat-form-field class="w200 float-right mat-height40 mat-input-style">
                        <input matInput [matDatepicker]="incrementEligibilityDate"  placeholder="DD/MM/YYYY">
                        <mat-datepicker-toggle matIconSuffix [for]="incrementEligibilityDate"></mat-datepicker-toggle>
                        <mat-datepicker #incrementEligibilityDate></mat-datepicker>
                      </mat-form-field>
                    </div>
                    <div *ngIf="selectLeaveAndAttendanceTab === 'attendanceForMonth'">
                      <span class="yellow fs-26 material-icons">notifications</span>
                    </div>
                  </div>
                </ion-col>
              </ion-row>
              
              <div *ngIf="selectLeaveAndAttendanceTab === 'TodaysAbsentees'">
                <ion-row *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'Admin' || loggedInUserRole == 'PHI Admin'">
                  <ion-col size="12">
                    <div class="leaveAndAttendanceTable">
                      <table>
                        <thead>
                          <tr>
                            <th>Name</th>
                            <th>Code</th>
                            <th>Reporting Mnagaer</th>
                            <th>Department</th>
                            <th>Attendance</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Abhijeet Mandle</td>
                            <td>Sample</td>
                            <td>Sample</td>
                            <td>Accounts</td>
                            <td>30/31</td>
                          </tr>
                          <tr>
                            <td>Abhijeet Mandle</td>
                            <td>Sample</td>
                            <td>Sample</td>
                            <td>Accounts</td>
                            <td>30/31</td>
                          </tr>
                          <tr>
                            <td>Abhijeet Mandle</td>
                            <td>Sample</td>
                            <td>Sample</td>
                            <td>Accounts</td>
                            <td>30/31</td>
                          </tr>
                          <tr>
                            <td>Abhijeet Mandle</td>
                            <td>Sample</td>
                            <td>Sample</td>
                            <td>Accounts</td>
                            <td>30/31</td>
                          </tr>
                          <tr>
                            <td>Abhijeet Mandle</td>
                            <td>Sample</td>
                            <td>Sample</td>
                            <td>Accounts</td>
                            <td>30/31</td>
                          </tr>
                          <tr>
                            <td>Abhijeet Mandle</td>
                            <td>Sample</td>
                            <td>Sample</td>
                            <td>Accounts</td>
                            <td>30/31</td>
                          </tr>
                          <tr>
                            <td>Abhijeet Mandle</td>
                            <td>Sample</td>
                            <td>Sample</td>
                            <td>Accounts</td>
                            <td>30/31</td>
                          </tr>
                          <tr>
                            <td>Abhijeet Mandle</td>
                            <td>Sample</td>
                            <td>Sample</td>
                            <td>Accounts</td>
                            <td>30/31</td>
                          </tr>
                          <tr>
                            <td>Abhijeet Mandle</td>
                            <td>Sample</td>
                            <td>Sample</td>
                            <td>Accounts</td>
                            <td>30/31</td>
                          </tr>
                          <tr>
                            <td>Abhijeet Mandle</td>
                            <td>Sample</td>
                            <td>Sample</td>
                            <td>Accounts</td>
                            <td>30/31</td>
                          </tr>
                          <tr>
                            <td>Abhijeet Mandle</td>
                            <td>Sample</td>
                            <td>Sample</td>
                            <td>Accounts</td>
                            <td>30/31</td>
                          </tr>
                          <tr>
                            <td>Abhijeet Mandle</td>
                            <td>Sample</td>
                            <td>Sample</td>
                            <td>Accounts</td>
                            <td>30/31</td>
                          </tr>
                          <tr>
                            <td>Abhijeet Mandle</td>
                            <td>Sample</td>
                            <td>Sample</td>
                            <td>Accounts</td>
                            <td>30/31</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </ion-col>
                </ion-row>
                
                <ion-row *ngIf="loggedInUserRole == 'Employee' || loggedInUserRole == 'Manager' || loggedInUserRole == 'HOD'" class="mt-20">
                  <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
                    <div class="calendar-container">
                      <div class="calendar-header">
                        <button (click)="previousMonth()">&#x276E;</button>
                        <span>{{ monthNames[currentMonth] }} {{ currentYear }}</span>
                        <button (click)="nextMonth()">&#x276F;</button>
                      </div>
                      
                      <div class="calendar-days">
                        <div *ngFor="let day of weekDays">{{ day }}</div>
                      </div>
                      
                      <div class="calendar-dates">
                        <div
                        *ngFor="let date of calendarDates; let i = index"
                        [ngClass]="{
                        'current-day': isToday(date),
                        'event-day': isEventDay(date),
                        'other-month': date.otherMonth
                        }"
                        (click)="onDateClick(date)"
                        >
                        {{ date.date }}
                      </div>
                    </div>
                  </div>
                </ion-col>
                
                <ion-col size-sm="12" size-md="7" size-lg="7" size-xs="12">
                  <div class="leaveManagementContent">
                    <div><img src="././assets/icon/swipeImg.svg" alt=""></div>
                    <div class="mt-20">
                      <p class="fs-12">Last Swipe : <span class="text_blue">No Swipe</span></p>
                      <p class="fs-12">Current IP : <span class="text_blue">103.179.39.223</span></p>
                    </div>
                    <div>
                      <button class="applyLeaveBtns mt-20">Punch In</button>
                    </div>
                    <div class="display-space-between mt-20">
                      <button class="applyLeaveBtns">Apply Leave</button>
                      <button class="applyLeaveBtns">Apply Outdoor</button>
                    </div>
                  </div>
                </ion-col>
              </ion-row >
              <ion-row class="mt-20" *ngIf="loggedInUserRole == 'Employee' || loggedInUserRole == 'Manager' || loggedInUserRole == 'HOD'">
                <ion-col size="12">
                  <div class="verticle-center">
                    <div class="verticle-center">
                      <div class="absentColorBox"></div>
                      <span class="fs-12 ml-10">Absent</span>
                    </div>
                    <div class="verticle-center ml-20">
                      <div class="PresentColorBox"></div>
                      <span class="fs-12 ml-10">Present</span>
                    </div>
                    <div class="verticle-center ml-20">
                      <div class="leaveAppliedColorBox"></div>
                      <span class="fs-12 ml-10">Leave Applied</span>
                    </div>
                    <div class="verticle-center ml-20">
                      <div class="leaveApprovedColorBox"></div>
                      <span class="fs-12 ml-10">Leave Approved</span>
                    </div>
                  </div>
                </ion-col>
              </ion-row>
            </div>
            
            <div *ngIf="selectLeaveAndAttendanceTab === 'attendanceForMonth'">
              <ion-row>
                <ion-col size="12">
                  <div class="leaveAndAttendanceTable">
                    <table >
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Code</th>
                          <th>Reporting Mnagaer</th>
                          <th>Department</th>
                          <th>Attendance</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Abhijeet Mandle</td>
                          <td>Sample</td>
                          <td>Sample</td>
                          <td>Accounts</td>
                          <td>30/31</td>
                        </tr>
                        <tr>
                          <td>Abhijeet Mandle</td>
                          <td>Sample</td>
                          <td>Sample</td>
                          <td>Accounts</td>
                          <td>30/31</td>
                        </tr>
                        <tr>
                          <td>Abhijeet Mandle</td>
                          <td>Sample</td>
                          <td>Sample</td>
                          <td>Accounts</td>
                          <td>30/31</td>
                        </tr>
                        <tr>
                          <td>Abhijeet Mandle</td>
                          <td>Sample</td>
                          <td>Sample</td>
                          <td>Accounts</td>
                          <td>30/31</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>                     
                </ion-col>
              </ion-row>
            </div>
            
            <div *ngIf="selectLeaveAndAttendanceTab === 'teamView'">
              <ion-row *ngIf="loggedInUserRole == 'Manager' || loggedInUserRole == 'HOD'" class="mt-20">
                <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
                  <div class="calendar-container">
                    <div class="calendar-header">
                      <button (click)="previousMonth()">&#x276E;</button>
                      <span>{{ monthNames[currentMonth] }} {{ currentYear }}</span>
                      <button (click)="nextMonth()">&#x276F;</button>
                    </div>
                    
                    <div class="calendar-days">
                      <div *ngFor="let day of weekDays">{{ day }}</div>
                    </div>
                    
                    <div class="calendar-dates">
                      <div
                      *ngFor="let date of calendarDates; let i = index"
                      [ngClass]="{
                      'current-day': isToday(date),
                      'event-day': isEventDay(date),
                      'other-month': date.otherMonth
                      }"
                      (click)="onDateClick(date)"
                      >
                      {{ date.date }}
                    </div>
                  </div>
                </div>
              </ion-col>
              
              <ion-col size-sm="12" size-md="7" size-lg="7" size-xs="12">
                <div>
                  <div class="text-end">
                    <mat-form-field class="w150 mat-height40 mat-input-style">
                      <mat-select placeholder="Select" placeholder="Serach employee">
                        <mat-option value="ABC">ABC</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
                <div class="leaveManagementContent mt-10">
                  <div><img src="././assets/icon/swipeImg.svg" alt=""></div>
                  <div class="mt-20">
                    <p class="fs-12">Last Swipe : <span class="text_blue">No Swipe</span></p>
                    <p class="fs-12">Current IP : <span class="text_blue">103.179.39.223</span></p>
                  </div>
                  <div class="display-space-between mt-20">
                    <button class="applyLeaveBtns">Regularize</button>
                    <button class="applyLeaveBtns">Approve leave</button>
                  </div>
                </div>
              </ion-col>
            </ion-row >
            <ion-row class="mt-20" *ngIf="loggedInUserRole == 'Manager' || loggedInUserRole == 'HOD'">
              <ion-col size="12">
                <div class="verticle-center">
                  <div class="verticle-center">
                    <div class="absentColorBox"></div>
                    <span class="fs-12 ml-10">Absent</span>
                  </div>
                  <div class="verticle-center ml-20">
                    <div class="PresentColorBox"></div>
                    <span class="fs-12 ml-10">Present</span>
                  </div>
                  <div class="verticle-center ml-20">
                    <div class="leaveAppliedColorBox"></div>
                    <span class="fs-12 ml-10">Leave Applied</span>
                  </div>
                  <div class="verticle-center ml-20">
                    <div class="leaveApprovedColorBox"></div>
                    <span class="fs-12 ml-10">Leave Approved</span>
                  </div>
                </div>
              </ion-col>
            </ion-row>
          </div>
        </div> --
      </div>
    </div>
  </ion-col>
  <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12">
    <div class="ELCMcardBox">
      <div class="fs-14 font_semibold">ELCM</div>
      <div style="text-align: center; margin-top: 40px;">Coming Soon</div>
      <!-- <ion-row *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'Manager' || loggedInUserRole == 'HOD'">
        <ion-col size="12">
          <div class="CLCMcardContent">
            <div>
              <div><img src="././assets/icon/agreement.svg" alt=""></div>
              <div><button type="button" class="btn">Employees in Probation</button></div>
            </div>
          </div>
        </ion-col>
      </ion-row> --
      <!-- <ion-row *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'Manager' || loggedInUserRole == 'HOD'">
        <ion-col size="12">
          <div class="CLCMcardContent">
            <div>Organisation Announcement
              <div><img src="././assets/icon/customer.svg" alt=""></div>
              <div><button type="button" class="btn">Employees Confirmed</button></div>
            </div>
          </div>
        </ion-col>
      </ion-row> --
      
      <!-- <ion-row *ngIf="loggedInUserRole == 'Employee'">
        <ion-col size="12">
          <div class="CLCMcardProbationContent"> 
            <img src="././assets/icon/agreement.svg" alt="">
            <button type="button" class="btn">Probation</button>
          </div>
        </ion-col>
      </ion-row> --
    </div>
  </ion-col>
</ion-row> -->
    <ion-row>
      <ion-col size="12">
        <div class="IJP-cardBox">
          <h4 class="fs-14 yellow font_semibold mt-5 cp">IJP (Internal Job Posting)</h4>

          <div class="table-wrapper ijp-table mt-5 ">
            <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8 my-custom-table">
              <ng-container matColumnDef="positionId">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="header-cell">Position ID</th>
                <td mat-cell *matCellDef="let element">{{ element.id }}</td>
              </ng-container>

              <ng-container matColumnDef="positionName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="header-cell">Position Name</th>
                <td mat-cell *matCellDef="let element">{{ element.positionName }}</td>
              </ng-container>

              <ng-container matColumnDef="vacancyCount">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="header-cell">No. of Vacancy</th>
                <td mat-cell *matCellDef="let element">{{ element.numberOfVacanciesForPosition }}</td>
              </ng-container>

              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="header-cell">Actions</th>
                <td mat-cell *matCellDef="let element">
                  <button mat-button color="primary" (click)="openViewPositionForm(element)">View</button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
          </div>
          <mat-paginator class="mob-hidden" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
        </div>
      </ion-col>
    </ion-row>
  </div>
</ion-content>
